import { useColorModeValue } from '@chakra-ui/color-mode';
import { Image } from '@chakra-ui/image';
import { Box, Center, Link, SimpleGrid, Text, VStack } from '@chakra-ui/layout';
import { Button } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { PROJECTS } from '../utils/constants';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ProjectCard = ({ name, image, clink, ghlink, key, projenabled }) => {
	AOS.init();

	const bgColorMode = useColorModeValue('gray.300', 'gray.600');

	if (projenabled === true) {
		return (
			<VStack
				maxWidth='200px'
				maxHeight='200px'
				background={bgColorMode}
				p={5}
				borderRadius='2xl'
				boxShadow='sm'
			>
				<Image
					width='350'
					height='350'
					src={`/images/${image}`}
					alt={image}
					loading='lazy'
				/>

				<Link
					href={clink}
					key={key}
					target='_blank'
					ml='1rem'
					mb='1rem'
				>
					<Text>{name}</Text>
				</Link>

				<Link target="_blank" href={ghlink}>
					<Button variant="ghost" colorScheme="teal" size="sm">View on GitHub</Button>
				</Link>
			</VStack>
		);
	} else {
		return null;
	}
};

const Projects = () => {
	useDocumentTitle();
	AOS.init();

	return (
		<Box
			background={useColorModeValue('gray.50', 'gray.800')}
			minHeight={{ md: 'calc(100vh - 120px)' }}
			p={{ base: 5, md: 10 }}
		>
			<Center data-aos="fade-down" data-aos-anchor-easing='ease-in-out' data-aos-anchor-placement="top-center">
				<VStack>
					<Text
						display='inline'
						mb={10}
					>
						Here you can find some of my uploaded projects, in which you can view the source code on GitHub.
					</Text>
					<SimpleGrid
						spacing={{ base: '5', md: '8' }}
						columns={{ base: 1, sm: 2, md: 4 }}
					>
						{PROJECTS.map(
							(names) => (
								<motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
									<ProjectCard {...names} />
								</motion.div>
							))}
					</SimpleGrid>
				</VStack>
			</Center>
		</Box>
	);
};

export default Projects;
